import React from 'react'
import makeStyles from '@mui/styles/makeStyles'
import { Box } from '@mui/material'

const useStyles = makeStyles((theme) => ({
  partnerCover: {
    backgroundColor: 'rgba(255,255,255,0.7)',
    position: 'relative',
    zIndex: 11,
    borderRadius: '8px',
    margin: '0 0 40px',
  },
  partnerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '16px 0 0',
    flexDirection: 'column',
    '& .logo': {
      height: '128px',
      margin: '0 24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    '& .logo img': {
      width: 'auto',
      height: '100%',
      display: 'block',
    },
    '& .logo-short': {
      margin: '32px 24px 0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
    },
    '& .logo-short img': {
      width: 'auto',
      height: '64px',
      display: 'block',
    },
    '& .logo-short h5': {
      fontSize: '18px',
      lineHeight: '24px',
      color: '#939393',
      display: 'block',
      margin: '0 0 8px',
    },
    '& .inspex img': {
      height: '64px',
      padding: '4px',
      borderRadius: '8px',
      backgroundColor: '#051026',
    },
    '& .killswitch img': { height: '48px' },
    '& .lattle img': {
      backgroundColor: '#fff',
      borderRadius: '8px',
    },
    '& .arken img': {},
    '& .inspex a': {
      color: '#fff',
      textDecoration: 'none',
    },
    '& .inspex div': {
      width: '100%',
    },
  },
  [theme.breakpoints.up('sm')]: {
    partnerContainer: {
      margin: '16px 0 0',
      flexDirection: 'row',
      '& .logo': {
        height: '64px',
        margin: '0 4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      '& .logo img': {
        width: 'auto',
        height: '100%',
        display: 'block',
      },
      '& .logo-short': {
        margin: '0 4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
      },
      '& .logo-short img': {
        width: 'auto',
        height: '38px',
        display: 'block',
      },
      '& .logo-short h5': {
        fontSize: '14px',
        lineHeight: '18px',
        display: 'block',
        margin: '0 0 8px',
      },
      '& .inspex img': {
        height: '48px',
        padding: '4px',
        borderRadius: '8px',
      },
      '& .killswitch img': { height: '48px' },
      '& .lattle img': {
        borderRadius: '8px',
      },
      '& .inspex a': {
        textDecoration: 'none',
      },
      '& .inspex div': {
        width: '100%',
      },
    },
  },
  [theme.breakpoints.up('md')]: {
    partnerContainer: {
      margin: '16px 0 0',
      '& .logo': {
        height: '112px',
        margin: '0 8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      '& .logo img': {
        width: 'auto',
        height: '100%',
        display: 'block',
      },
      '& .logo-short': {
        margin: '0 12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
      },
      '& .logo-short img': {
        width: 'auto',
        height: '56px',
        display: 'block',
      },
      '& .logo-short h5': {
        fontSize: '18px',
        lineHeight: '24px',
        display: 'block',
        margin: '0 0 8px',
      },
      '& .inspex img': {
        height: '56px',
        padding: '4px',
        borderRadius: '8px',
      },
      '& .killswitch img': { height: '48px' },
      '& .lattle img': {
        borderRadius: '8px',
      },
      '& .inspex a': {
        textDecoration: 'none',
      },
      '& .inspex div': {
        width: '100%',
      },
    },
  },
  [theme.breakpoints.up('lg')]: {
    partnerContainer: {
      margin: '16px 0 0',
      flexDirection: 'row',
      '& .logo': {
        height: '128px',
        margin: '0 30px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      '& .logo img': {
        width: 'auto',
        height: '100%',
        display: 'block',
      },
      '& .logo-short': {
        margin: '0 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      '& .logo-short img': {
        width: 'auto',
        height: '64px',
        display: 'block',
      },
      '& .logo-short h5': {
        fontSize: '18px',
        lineHeight: '24px',
        display: 'block',
        margin: '0 0 8px',
      },
      '& .inspex img': {
        height: '64px',
        padding: '4px',
        borderRadius: '8px',
      },
      '& .killswitch img': { height: '48px' },
      '& .lattle img': {
        borderRadius: '8px',
      },
      '& .inspex a': {
        textDecoration: 'none',
      },
      '& .inspex div': {
        width: '100%',
      },
    },
  },
}))

const Partner = () => {
  const classes = useStyles()
  return (
    <Box className={classes.partnerCover}>
      <Box style={{ margin: '0' }} className={classes.partnerContainer}>
        <Box className="logo foodcourt">
          <img src="/images/logo/foodcourt.svg" alt="" />
        </Box>
        <Box className="logo killswitch">
          <img src="/images/logo/killswitch.svg" alt="" />
        </Box>
        <Box className="logo latte">
          <img src="/images/logo/latte.svg" alt="" />
        </Box>

        <Box className="logo aqua">
          <img src="/images/logo/aqua.svg" alt="" />
        </Box>
      </Box>
      <Box className={classes.partnerContainer}>
        <Box className="logo-short nomics">
          <h5>&nbsp;</h5>
          <img src="/images/logo/nomics.png" alt="" />
        </Box>
        <Box className="logo-short arken">
          <h5>&nbsp;</h5>
          <img src="/images/logo/arken.svg" alt="" />
        </Box>
        <Box className="logo-short inspex">
          <h5>Audit By</h5>
          <a href="https://link.inspex.co/library-samoyedfinance-token-masterchef" rel="noreferrer" target="_blank">
            <img src="/images/logo/inspex.png" alt="" />
          </a>
        </Box>
        <Box className="logo-short chainlink">
          <h5>Oracle Prizes by</h5>
          <img src="/images/logo/badge_chainlink.png" alt="" />
        </Box>
      </Box>
    </Box>
  )
}

export default Partner
